<template>
  <div :class="`container ${plat}`">
    <div class="page page-02">
      <div class="pg-tit" :style="psy">
        <img :src="tabType != 1 ? require('../../assets/img_post.png') : require('../../assets/img-sz.png')" alt="">
      </div>
      <div class="pg02-cnt">
        <!-- 岗位类别 && 搜索 -->
        <div class="pg02-right">
          <s-input :readonly="readonly" seat="In"></s-input>
        </div>
        <!-- 岗位列表 -->
        <div class="pg02-left">
          <!-- <div class="h1" :style="psy">盈趣科技2021年校园招聘</div>
          <div class="h4" :style="psy">同学们好，盈趣科技2021年校园招聘开始啦！</div>-->
          <div class="totalNum">共 {{ $store.state.showedPostLen }} 个岗位</div>
          <div :style="msy">
            <ul v-if="$store.state.activeMobile == 1">
              <li :class="['li-card', 'show']" v-for="(d, index) of $store.state.showedPostData" :key="index"
                style="padding:10px 24px 15px 24px">
                <div class="card-tit" @click="expContent(index, d.positionId, d.type, d.recruitmentId)">
                  <p class="card-tit-fsp-m">{{ d.positionName }}</p>
                  <p class="card-tit-sep">{{ d.jobCategoryName ? d.jobCategoryName : '--' }} | {{ d.company ? d.company
                      :
                      '--'
                  }} | {{d.workPlaceRegion ? d.workPlaceRegion : '--'}}</p>
                  <!-- <div class="card-tit-thp">
                  <p>1、 根据软件开发需求，完成软件项目设计开发；</p>
                  <p>2、 负责嵌入式平台软件整体设计、产品方案评估及选型；</p>
                </div>-->
                </div>
                <!-- <div class="card-cnt">
                <div v-for="dd of d.detail" :key="dd.title">
                  <h4>{{dd.title}}：</h4>
                  <p v-for="ddd of dd.text" :key="ddd.index">{{ddd}}</p>
                </div>
                <div class="deliver-in" @click.stop="showApply(d.name,d.company)">申请职位</div>
              </div>-->
              </li>
            </ul>
            <ul v-if="$store.state.activeMobile == 2">
              <li :class="['li-card', 'show']" v-for="(d, index) of $store.state.showedPostData" :key="index"
                style="padding:10px 24px 15px 24px">
                <div class="card-tit" @click="expContent(index, d.positionId, d.type, d.recruitmentId)">
                  <p class="card-tit-fsp-m">{{ d.positionName }}</p>
                  <p class="card-tit-sep">{{ d.jobCategoryName ? d.jobCategoryName : '--' }} | {{ d.company ? d.company
                      :
                      '--'
                  }} | {{d.workPlaceRegion ? d.workPlaceRegion : '--'}}</p>
                  <!-- <div class="card-tit-thp">
                  <p>1、 根据软件开发需求，完成软件项目设计开发；</p>
                  <p>2、 负责嵌入式平台软件整体设计、产品方案评估及选型；</p>
                </div>-->
                </div>
                <!-- <div class="card-cnt">
                <div v-for="dd of d.detail" :key="dd.title">
                  <h4>{{dd.title}}：</h4>
                  <p v-for="ddd of dd.text" :key="ddd.index">{{ddd}}</p>
                </div>
                <div class="deliver-in" @click.stop="showApply(d.name,d.company)">申请职位</div>
              </div>-->
              </li>
            </ul>
          </div>

          <ul :style="psy">
            <li :class="['li-card', 'show']"
              v-for="(d, index) of $store.state.showedPagingPost[$store.state.currPagingNum]" :key="index">
              <div class="card-tit" @click="expContent(index, d.positionId, d.type, d.recruitmentId)">
                <p class="card-tit-fsp">{{ d.positionName }}</p>
                <p class="card-tit-sep">{{ d.jobCategoryName ? d.jobCategoryName : '--' }} | {{ d.company ? d.company :
                    '--'
                }} | {{d.workPlaceRegion ? d.workPlaceRegion : '--'}}</p>
                <!-- <div class="card-tit-thp">
                  <p>1、 根据软件开发需求，完成软件项目设计开发；</p>
                  <p>2、 负责嵌入式平台软件整体设计、产品方案评估及选型；</p>
                </div>-->
              </div>
            </li>
          </ul>
          <div class="page-cnt" :style="psy">
            <a-pagination v-show="$store.state.showedPostLen > 0" :defaultCurrent="$store.state.currPagingNum + 1"
              :total="$store.state.showedPagingNum * 10" @change="pageChange" />
            <!-- <div class="page-cnt-box" v-show="$store.state.showedPostLen > 0">
              <div class="pbox" @click.stop="changePage('last')"><i class="i-left"></i></div>
              <div :class="`${d === '...' ? 'ellipsis' : 'pbox'} ${$store.state.currPagingNum + 1 == d ? 'active' : ''}`" v-for="(d,index) in $store.state.showedPagingNum" :key="index" @click.stop="changePage(d)">{{d}}</div>
              <div class="pbox" @click.stop="changePage('next')"><i class="i-right"></i></div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sInput from '@/components/s-input/s-input.vue'
import cmJs from '@/components/common/common.js'

export default {
  components: {
    sInput
  },
  data() {
    return {
      readonly: false,
      expCnt: 0,
      plat: `plat-${this.$store.state.plat}`,
      psy: { display: this.$store.state.plat === 'Web' ? '' : 'none' },
      msy: { display: this.$store.state.plat === 'Mobile' ? '' : 'none' },
      dataFrom: {
        positionName: '',
        pay: '',
        payShow: '',
        companyId: '',
        type: '1',
        currentPage: '',
        pageSize: '',
      },
      tabType: null,
      flag: null
    }
  },
  mounted() {
    this.tabType = this.GetQueryString('type')
    // this.$store.state.allPostData = arr;
    this.$store.commit('setShowedPost', undefined)

    if (this.$store.state.plat === 'Mobile') {
      this.readonly = true;
      if (this.$store.state.activeMobile == 1) {
        this.getSalaryRangeOr(1)
      } else {
        this.getSalaryRangeOr(2)
      }
    } else {
      this.getSalaryRangeOr(this.GetQueryString('type'))
    }
    // if(this.$route.query.companyType) { // 默认显示公司岗位，0盈趣，1攸信
    //   this.$store.state.selectedCompanyArr.push(this.$route.query.companyType)
    // }

  },
  methods: {
    //判断上个页面传过来的参数
    GetQueryString(name) {
      var after = window.location.hash.split("?")[1];
      if (after) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = after.match(reg);
        if (r != null) {
          return decodeURIComponent(r[2]);
        }
        else {
          return null;
        }
      }
    },
    pageChange(page, pageSize) {
      this.$store.state.currPagingNum = page - 1;
    },
    showApply(pName, comp) {
      this.$emit('showApply', pName, comp)
    },
    expContent(i, positionId, type, id) {
      this.$router.push('detail?tab=' + this.$store.state.activeTopTab + '&id=' + positionId + '&type=' + type + '&recruitmentId=' + id)
    },
    changePage(pg) {
      let pageNum = this.$store.state.currPagingNum;
      if (pg !== '...' && pg !== 'last' && pg !== 'next') {
        pageNum = pg - 1;
      }
      else if (pg === 'last') {
        pageNum--;
        if (pageNum <= 0) pageNum = 0
      }
      else if (pg === 'next') {
        pageNum++;
        if (pageNum >= this.$store.state.showedPagingPost.length) pageNum = this.$store.state.showedPagingPost.length;
      }
      this.$store.state.currPagingNum = pageNum;
    },
    //判断上个页面传过来的参数
    GetQueryString(name) {
      var after = window.location.hash.split("?")[1];
      console.info(after)
      this.flag = after
      if (after) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = after.match(reg);
        if (r != null) {
          return decodeURIComponent(r[2]);
        }
        else {
          return null;
        }
      }
    },
    //获取在招岗位
    getSalaryRangeOr(val) {
      let that = this
      that.dataFrom['type'] = val
      this.$request({
        api: '/uhrm/website/postWebsite',
        type: 'GET',
        param: that.dataFrom,
        success: function (res) {
          that.$store.state.allPostData = res.data;
          that.$store.commit('setShowedPost', undefined)
        },
        error: function (err) {
          console.log('失败1。。', err)
          cmJs.modalToast(err.msg)
        }
      })
    }
  },
  watch: {
    '$store.state.activeMobile'(newVal, oldVal) {
      console.log("newVal:", newVal)
      //对数据执行操作
      if (this.$store.state.plat === 'Mobile') {
        if (newVal == 1) {
          this.getSalaryRangeOr(1)//社会招聘
          console.info('社会招聘')
        } else {
          this.getSalaryRangeOr(2)//校园招聘
          console.info('校园招聘')
        }
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "../../components/common/common.less";

.plat-Mobile {
  height: unset;
  min-height: 100%;

  .page-02 {
    height: unset;
    min-height: 100%;

    .pg02-cnt {
      padding: 0;
      height: unset;
      min-height: 100%;

      .pg02-right {
        float: unset;
        width: 100%;
        height: unset;
        border: none;
        margin-right: 0;
        border-radius: 0;
      }

      .pg02-left {
        float: unset;
        width: 100%;
        height: unset;
        min-height: 100%;
        padding: 10px 14px 20px 14px;

        ul {
          height: unset;
          min-height: calc(100vh - 130px);
        }

        .li-card {
          .arrow {
            display: none;
          }
        }
      }
    }
  }
}

.page-02 {
  height: 100%;

  .pg02-cnt {
    width: 100%;
    height: calc(100% - 162px);
    padding: 26px 18% 0 18%;
    box-sizing: border-box;

    .pg02-right {
      width: 208px;
      border: 1px solid #eee;
      border-radius: 5px;
      height: 420px;
      box-sizing: border-box;
      margin-right: 12px;
      float: left;
    }

    .pg02-left {
      width: calc(100% - 220px);
      height: 100%;
      // padding: 47px 32px 20px 32px;
      padding: 32px 32px 20px 32px;
      box-sizing: border-box;
      // background: #F5F5F5;
      // border-radius: 5px;
      background: #f0f0f0;
      border-radius: 4px;
      float: left;

      .h1 {
        margin-bottom: 15px;
        font-size: 22px;
        font-weight: bold;
      }

      .h4 {
        margin-bottom: 30px;
        font-size: 12px;
      }

      ul {
        width: 100%;
        // height: calc(100% - 120px);
        min-height: 500px;
        height: calc(100% - 80px);
        padding-right: 2px;
        box-sizing: border-box;
        .cmScroll(hidden, auto, transparent, 8px);
      }

      .totalNum {
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #666666;
        margin-bottom: 12px;
        font-size: 12px;
      }

      .li-card {
        margin-bottom: 12px;
        border-radius: 5px;
        background: #fff;
        width: 100%;
        height: max-content;
        padding: 20px 24px;
        box-sizing: border-box;
        position: relative;
        display: none;

        &.show {
          display: block;
        }

        &.exp {
          .card-cnt {
            display: block;
          }

          .arrow>img {
            &:first-child {
              display: inline-block;
            }

            &:last-child {
              display: none;
            }
          }
        }

        p {
          margin-top: 5px;
        }

        h4 {
          margin-bottom: 7px;
        }

        .card-cnt {
          margin-top: 12px;
          display: none;

          &>div {
            margin-top: 12px;
          }
        }

        .card-tit {
          cursor: pointer;

          .card-tit-fsp {
            font-size: 24px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            line-height: 28px;
            color: #1f2329;
          }

          .card-tit-fsp-m {
            font-size: 16px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: #1f2329;
          }

          .card-tit-sep {
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            line-height: 28px;
            color: #646a73;
          }

          .card-tit-sep-m {
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            line-height: 28px;
            color: #646a73;
          }

          .card-tit-thp {
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            line-height: 23px;
            color: #92959b;
          }
        }

        .arrow {
          position: absolute;
          top: 20px;
          right: 28px;
          width: 15px;
          cursor: pointer;

          img {
            width: 100%;

            &:first-child {
              display: none;
            }

            &:last-child {
              display: inline-block;
            }
          }
        }

        .deliver-in {
          border: 1px solid #ff5f00;
          color: #ff5f00;
          padding: 4px 10px;
          text-align: center;
          width: max-content;
          margin-top: 12px;
          cursor: pointer;
        }
      }

      .page-cnt {
        margin-top: 20px;

        .ant-pagination {
          // width: max-content;
          width: auto;
          min-height: 33px;
          height: 33px;
          float: right;
        }

        .page-cnt-box {
          display: flex;
          justify-content: flex-end;
          padding-right: 2px;

          .ellipsis {
            margin-right: 8px;
            font-weight: bold;
            font-size: 18px;
            line-height: 18px;
            color: #666;
          }

          .pbox {
            width: 28px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: #fff;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            font-size: 12px;
            color: #666;
            margin-right: 8px;
            cursor: pointer;

            &.active {
              border: 1px solid #ff5f00;
              color: #ff5f00;
            }

            i {
              border: solid #666;
              border-width: 0 1px 1px 0;
              display: inline-block;
              padding: 3px;

              &.i-left {
                transform: rotate(135deg);
                -webkit-transform: rotate(135deg);
              }

              &.i-right {
                transform: rotate(-45deg);
                -webkit-transform: rotate(-45deg);
              }
            }
          }
        }
      }
    }

    &::after {
      content: " ";
      display: block;
      clear: both;
    }
  }

  &::after {
    content: " ";
    display: block;
    clear: both;
  }
}

.page-box {
  float: left;
  padding: 23px 0;

  .page-name {
    margin-top: 10px;
    font-size: 36px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    line-height: 36px;
    color: #ffffff;
    letter-spacing: 3px;
  }

  .page-welcome {
    margin-top: 22px;
    font-size: 28px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 28px;
    color: #ffffff;
    letter-spacing: 3px;
  }
}

.pg-logo {
  float: right;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 200px;
    height: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/cap-page-02/cap-page-02.vue